import { heroStats } from '@/mocks/homepage';

export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-[600px] lg:min-h-[700px] flex items-center pt-[72px] overflow-hidden">
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/40 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/30 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="w-full lg:w-[55%] flex flex-col items-start gap-5 pt-8 lg:pt-0">
            <div className="flex items-center gap-2 px-3 py-1.5 bg-primary-100 text-primary-700 rounded-full text-sm font-medium whitespace-nowrap">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              吃瓜第一线 · 实时追踪
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              吃瓜官网
              <span className="block text-primary-600 mt-1">娱乐圈一手爆料平台</span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl">
              吃瓜官网是专业娱乐资讯与八卦爆料聚合平台，为您提供51吃瓜官网首页进入、吃瓜网站最新地址及51吃瓜官方入口。我们7×24小时追踪娱乐圈动态，汇聚全网最新最热的明星八卦、综艺爆料、影视吐槽和独家深扒内容。当前热榜密集更新中，多名顶流艺人动态值得关注，安全直达吃瓜平台首页，畅享八卦爆料。
            </p>

            <div className="flex items-center gap-6 md:gap-8 flex-wrap">
              {heroStats.map((stat) => (
                <div key={stat.label} className="flex flex-col items-start">
                  <span className="text-2xl md:text-3xl font-heading font-bold text-primary-600">{stat.value}</span>
                  <span className="text-xs md:text-sm text-foreground-500">{stat.label}</span>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-3 flex-wrap">
              <a
                href="#topics"
                onClick={(e) => { e.preventDefault(); scrollTo('#topics'); }}
                className="px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 text-sm whitespace-nowrap cursor-pointer"
              >
                立即吃瓜
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); scrollTo('#ranking'); }}
                className="px-6 py-3 border-2 border-background-300 text-foreground-700 font-medium rounded-full hover:border-primary-400 hover:text-primary-600 transition-colors duration-200 text-sm whitespace-nowrap cursor-pointer"
              >
                热度榜单
              </a>
            </div>
          </div>

          <div className="w-full lg:w-[45%] flex items-center justify-center">
            <div className="relative w-full max-w-md lg:max-w-none">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20entertainment%20magazine%20cover%20design%20with%20bold%20modern%20typography%2C%20vibrant%20coral%20red%20and%20warm%20gold%20gradients%2C%20geometric%20abstract%20shapes%20overlapping%2C%20glossy%20editorial%20aesthetic%2C%20dramatic%20lighting%20effect%2C%20clean%20minimalist%20composition%20with%20negative%20space%2C%20sophisticated%20and%20eye-catching%20visual%20style&width=800&height=600&seq=hero-main&orientation=landscape"
                  alt="吃瓜官网 - 娱乐圈爆料平台主视觉"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 w-24 h-24 bg-accent-400 rounded-2xl flex items-center justify-center">
                <span className="text-background-50 text-xs font-bold text-center leading-tight">今日<br />热榜</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}